<template>
  <section
    class="flex flex-col items-center justify-center gap-5 rounded-lg border-2 border-dashed border-gray-200 bg-gray-50/70 py-10 text-center"
  >
    <div class="text-md max-w-md font-thin tracking-tight text-gray-600">
      <slot />
    </div>
    <Btn
      v-if="!noButton"
      size="sm"
      icon-position="right"
      :variant="Variant.success"
      :data-id="dataId || 'new-resource'"
      :icon-badge="icon"
      :tag="to ? 'NuxtLink' : 'button'"
      :to="to || '#'"
      :title="title"
      icon="create"
      @click="click"
      >{{ title }}
    </Btn>
  </section>
</template>
<script setup lang="ts">
import Btn from '../../components/form/Btn.vue';
import { Variant } from '../../store/types';
import type { MsIcon } from '../../lib/services/types';

withDefaults(
  defineProps<{
    noButton?: boolean;
    icon?: MsIcon;
    dataId?: string;
    to?: string;
    title?: string;
  }>(),
  {
    dataId: '',
    noButton: false,
    title: undefined,
    to: '',
    icon: undefined,
  },
);
const emit = defineEmits<{ (e: 'click'): void }>();
const click = () => emit('click');
</script>
